import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['cathedral', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-5.5h0.5v1h-0.5zM-0.5,-5h0.5v0.5h-0.5zM-3,-4.5h1v0.5h-1zM-1,-4.5h1v1.5h-1zM-3,-4h1.5v0.5h-1.5zM-3,-3.5h1v1h-1zM-0.5,-3h0.5v1h-0.5zM-3,-2.5h0.5v2.5h-0.5zM-3.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['cathedral', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-3.5,-8h0.5v0.5h-0.5zM-1,-6.5h0.5v0.5h-0.5zM-3,-6h1.5v0.5h-1.5zM2.5,-6h1.5v0.5h-1.5zM-2.5,-5.5h2v0.5h-2zM1.5,-5.5h1.5v0.5h-1.5zM3.5,-5.5h0.5v6h-0.5zM-1.5,-5h1v0.5h-1zM0.5,-5h1v0.5h-1zM2,-5h1v0.5h-1zM1,-4.5h0.5v5.5h-0.5zM2,-4.5h0.5v3h-0.5zM-1.5,-4h0.5v0.5h-0.5zM-2,-3.5h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM-0.5,-1.5h0.5v2.5h-0.5zM2,-1.5h1v2h-1zM2,0.5h1.5v0.5h-1.5zM-1,1h1v0.5h-1zM1,1h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-10h0.5v0.5h-0.5zM-2,-9.5h0.5v0.5h-0.5zM-2.5,-9h1.5v1h-1.5zM-3,-8h2.5v0.5h-2.5zM-3,-7.5h3v0.5h-3zM-3,-7h3.5v0.5h-3.5zM-3,-6.5h1v0.5h-1zM-0.5,-6.5h1v0.5h-1zM3.5,-6.5h0.5v0.5h-0.5zM-0.5,-6h1.5v0.5h-1.5zM2,-6h0.5v0.5h-0.5zM-0.5,-5.5h2v0.5h-2z',
    },
    {
      paint: 'roofA',
      d: 'M0,-10.5h1.5v0.5h-1.5zM-1,-10h3v0.5h-3zM-1.5,-9.5h4v0.5h-4zM-1,-9h4v0.5h-4zM-1,-8.5h4.5v0.5h-4.5zM-0.5,-8h4v0.5h-4zM0,-7.5h4v0.5h-4zM0.5,-7h4v0.5h-4zM0.5,-6.5h3v0.5h-3zM1,-6h1v0.5h-1z',
    },
    {
      paint: 'cathedral',
      d: 'M-4,-8h0.5v0.5h-0.5zM-4,-7.5h1v2h-1zM-1.5,-6h0.5v0.5h-0.5zM-3.5,-5.5h0.5v5.5h-0.5zM3,-5.5h0.5v6h-0.5zM-2.5,-5h0.5v0.5h-0.5zM0,-5h0.5v0.5h-0.5zM1.5,-5h0.5v6h-0.5zM-2,-4.5h1v0.5h-1zM0,-4.5h1v2.5h-1zM-0.5,-2h1.5v0.5h-1.5zM0,-1.5h1v3h-1zM0.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'shadow',
      d: 'M-1.5,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM-2.5,-2h0.5v2h-0.5zM-1,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1.5,-3h0.5v0.5h-0.5zM-2,-2.5h1v1h-1zM-2,-1.5h1.5v1.5h-1.5zM-2.5,0h2v0.5h-2zM-1.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'chimney',
      d: 'M-2,-5h0.5v0.5h-0.5zM-2.5,-2.5h0.5v0.5h-0.5zM-1,-2.5h0.5v0.5h-0.5zM-2,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'cathedralWindow', d: 'M-2,-6.5h1v0.5h-1zM-1,-6h0.5v0.5h-0.5zM2.5,-4.5h0.5v3h-0.5z' },
    {
      paint: [
        ['roofA', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-4,-10.5h1v2h-1zM-4.5,-8.5h2v0.5h-2z',
    },
    {
      paint: 'church',
      d: 'M-2,-12h1v0.5h-1zM-2.5,-11.5h2v1h-2zM-2,-10.5h1v0.5h-1zM-2,-10h0.5v0.5h-0.5z',
    },
  ],
  pixels: 346,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
